import { AdditionalInfoModel } from 'app/services/additional-info/additional-info.service';

export const additionalInfoFields: AdditionalInfoModel.Category[] = [
  {
    name: 'Staff Current Assignments',
    expanded: true,
    fields: [
      { 
        name: 'Assignment Code', 
        key: 'assignmentCode', 
        selected: false,
        exportColumn: {
          jsonPath: '$.assignmentCode'
        }
      },
      { 
        name: 'Current Assignment Begin Date', 
        key: 'assignmentBeginDate', 
        selected: false,
        exportColumn: {
          jsonPath: '$.assignmentBeginDate'
        }
      },
      { 
        name: 'Current Assignment End Date', 
        key: 'assignmentEndDate', 
        selected: false,
        exportColumn: {
          jsonPath: '$.assignmentEndDate'
        }
      }
    ]
  },
  {
    name: 'Staff Licensure & Endorsement Details',
    expanded: true,
    fields: [
      { 
        name: 'Experience', 
        key: 'experienceInYears', 
        selected: false,
        exportColumn: {
          jsonPath: '$.experienceInYears'
        }
      },
      { 
        name: 'Education Level', 
        key: 'educationLevel', 
        selected: false,
        exportColumn: {
          jsonPath: '$.educationLevel'
        }
      },
      { 
        name: 'Conferral Date', 
        key: 'conferralDate', 
        selected: false,
        exportColumn: {
          jsonPath: '$.conferralDate'
        }
      },
      { 
        name: 'Date Added to File', 
        key: 'addedToFile', 
        selected: false,
        exportColumn: {
          jsonPath: '$.addedToFile'
        }
      },
      { 
        name: 'Date Issued', 
        key: 'additionalInfo.staffMemberLicensureDetails.dateIssued', 
        selected: false,
        exportColumn: {
          jsonPath: '$.additionalInfo.StaffMemberLicensureDetails.dateIssued'
        }
      },
      { 
        name: 'Type', 
        key: 'additionalInfo.staffMemberLicensureDetails.type', 
        selected: false,
        exportColumn: {
          jsonPath: '$.additionalInfo.StaffMemberLicensureDetails.type'
        }
      },
      { 
        name: 'Expiration Date', 
        key: 'additionalInfo.staffMemberLicensureDetails.expirationDate', 
        selected: false,
        exportColumn: {
          jsonPath: '$.additionalInfo.StaffMemberLicensureDetails.expirationDate'
        }
      },
      { 
        name: 'Renewed Date', 
        key: 'additionalInfo.staffMemberLicensureDetails.renewedDate', 
        selected: false,
        exportColumn: {
          jsonPath: '$.additionalInfo.StaffMemberLicensureDetails.renewedDate'
        }
      },
      { 
        name: 'Number of Renewals', 
        key: 'additionalInfo.staffMemberLicensureDetails.numberOfRenewals', 
        selected: false,
        exportColumn: {
          jsonPath: '$.additionalInfo.StaffMemberLicensureDetails.numberOfRenewals'
        }
      }
    ]
  }
];